import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import i18n from "i18next";

import { DropDown } from "../../Common/DropDown";
import Button from "../../Common/Button";

export class Export extends PureComponent {
  static propTypes = {
    actions: PropTypes.array,
    filter: PropTypes.bool
  };

  static defaultProps = {
    actions: [],
    filter: false
  };

  state = {
    isDropdownOpen: false
  };

  handleCloseDropdown = () => {
    this.setState({ isDropdownOpen: false });
    document.removeEventListener("click", this.handleCloseDropdown);
  };

  handleToggleDropdown = () => {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    document.addEventListener("click", this.handleCloseDropdown);
  };

  render() {
    const { actions, filter } = this.props;
    return (
      <div className="exports__right">
        <Button
          className={classNames("button__export", filter && "--filter")}
          labelClass="button__box-label --export"
          label={i18n.t("export.export")}
          onClick={this.handleToggleDropdown}
          icon="table"
          withArrowDown
        />
        <DropDown className={classNames("exports__dropdown", filter && "--filter")} contentTag="menu" isOpen={this.state.isDropdownOpen}>
          {actions.map(action => (
            <button key={action.key} className="exports__dropdown-link" onClick={action.onClick}>
              {action.label}
            </button>
          ))}
        </DropDown>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/Export/Export.js